<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;">
    <highcharts
      class="mt-4"
      :options="options"
      ref="aChart"
      style="width: 100%; height: 100%;"
    ></highcharts>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CumulativeOpe',
  props: {
    thisMachines: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.chart = this.$refs.aChart.chart;
    this.createSeries();
    this.initResizeObserver();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect(); // 👈 cleanup
  },
  data() {
    return {
      resizeObserver: null,
      chart: null,
      options: {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, sans-serif',
          },
        },
        title: {
          text: 'Cumulative OPE (%)',
          style: {
            color: '',
          },
        },
        plotOptions: {
          series: {
            grouping: false,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            color: '#333',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          type: 'category',
          labels: {
            style: {
              color: '',
            },
          },
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: {
              style: {
                color: '',
              },
            },
          },
        ],
        series: [{}],
      },
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('kpiDashboard', ['thisDate']),
  },
  methods: {
    roundOff(val) {
      if (val) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    createSeries() {
      const actualData = this.thisMachines.map((m) => ({
        name: m.machinename,
        y: this.roundOff(m.a),
      }));
      const targetData = this.thisMachines.map((m) => ({
        name: m.machinename,
        y: parseFloat(m.targetLine) || 0,
      }));

      this.options.xAxis.categories = this.thisMachines.map((m) => m.machinename);
      this.options.series = [
        {
          name: 'Target',
          type: 'line',
          data: targetData,
          color: '#1CA4D7',
          dashStyle: 'ShortDash',
          zIndex: 5,
          marker: {
            enabled: true,
            radius: 3,
          },
          dataLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: this.isDark ? '#FFFFFF' : '#000000',
            },
            formatter() {
              return this.y;
            },
          },
        },
        {
          name: `${this.thisDate}`,
          type: 'column',
          id: 'main',
          data: actualData,
          color: this.isDark ? '#21C77C' : '#354493',
          dataLabels: {
            enabled: true,
            style: {
              color: this.isDark ? '#FFFFFF' : '#000000',
              fontWeight: 'bold',
            },
          },
        },
      ];

      this.$nextTick(() => this.reflowChart());
    },
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.reflowChart();
      });
      if (this.$refs.chartContainer) {
        this.resizeObserver.observe(this.$refs.chartContainer);
      }
    },
    reflowChart() {
      this.$nextTick(() => {
        const chartInstance = this.$refs.aChart?.chart;
        if (chartInstance && chartInstance.reflow) {
          chartInstance.reflow();
        }
      });
    },
  },
  watch: {
    thisMachines: {
      deep: true,
      handler() {
        this.createSeries();
      },
    },
    isDark: {
      immediate: true,
      handler(val) {
        const color = val ? '#FFFFFF' : '#333333';
        const labelColor = val ? '#1CA4D7' : '#666666';
        const seriesColor = val ? '#5F4E94' : '#354493';
        this.options.title.style.color = color;
        this.options.yAxis[0].labels.style.color = labelColor;
        this.options.xAxis.labels.style.color = labelColor;
        if (this.options.series[0]) {
          this.options.series[0].color = seriesColor;
        }
      },
    },
  },
};
</script>
